<section [classList]="show ? 'show' : ''" #intro>
  Du suchst eine neue <span>Location</span> für dein <span>Dart-Team</span>?<br>
  <span class="subText">Dann komm vorbei und quatsch mit uns!</span>
</section>
